import React from 'react';
import useClockTime from '../useClockTime';

const DESIGN_W = 380;
const DESIGN_H = 140;

const DigitalLarge = ({
  textColor = '#1f3a5f',
  fontFamily,
  accentColor = '#c8a84b',
}) => {
  const { hours24, minutes, seconds } = useClockTime();

  const hh = String(hours24).padStart(2, '0');
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');

  const bigNumStyle = {
    fontSize: 100,
    fontWeight: 700,
    color: textColor,
    fontFamily: fontFamily || 'inherit',
    fontVariantNumeric: 'tabular-nums',
    lineHeight: 1,
    width: 136,
    textAlign: 'center',
    display: 'block',
    flexShrink: 0,
  };
  const bigColonStyle = {
    fontSize: 90,
    fontWeight: 700,
    color: accentColor,
    fontFamily: fontFamily || 'inherit',
    lineHeight: 1,
    width: 22,
    textAlign: 'center',
    flexShrink: 0,
    userSelect: 'none',
  };
  const smallNumStyle = {
    fontSize: 42,
    fontWeight: 600,
    color: textColor,
    fontFamily: fontFamily || 'inherit',
    fontVariantNumeric: 'tabular-nums',
    lineHeight: 1,
    width: 58,
    textAlign: 'center',
    display: 'block',
    flexShrink: 0,
    opacity: 0.75,
    marginBottom: 4,
  };
  const smallColonStyle = {
    fontSize: 38,
    fontWeight: 600,
    color: accentColor,
    fontFamily: fontFamily || 'inherit',
    lineHeight: 1,
    width: 16,
    textAlign: 'center',
    flexShrink: 0,
    userSelect: 'none',
    opacity: 0.75,
    marginBottom: 4,
  };

  return (
    <div style={{ width: DESIGN_W, height: DESIGN_H, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', direction: 'ltr' }}>
        <span style={bigNumStyle}>{hh}</span>
        <span style={bigColonStyle}>:</span>
        <span style={bigNumStyle}>{mm}</span>
        <span style={smallColonStyle}>:</span>
        <span style={smallNumStyle}>{ss}</span>
      </div>
    </div>
  );
};

export default DigitalLarge;
